import { useTranslation } from 'react-i18next';
import { PricingPackagesFormValues } from '../../../../../../store/features/packages/types';
import { PricingProductOptionsGroup } from '../../../../../../store/features/products/types';

import { MuiStack } from '../../../../../../../../modules/material';
import CardWrapper from '../../shared/CardWrapper';
import SecondLevelCard from '../../shared/SecondLevelCard';
import Typography from '../../../../../../shared/library/Typography';
import SecondLevelListWrapper from '../../shared/SecondLevelListWrapper';
import RadioGroupField from '../../../../../../shared/formElements/RadioGroupField';
import Radio from '../../../../../../shared/library/Radio';
import ProductTooltipInfoIcon from '../../shared/TooltipInfoIcon';
import TitleWithInlineElement from '../../shared/TitleWithInlineElement';

export interface SingleOptionsListProps {
  optionGroup: PricingProductOptionsGroup;
  index: number;
}

export default function SingleOptionsList(props: SingleOptionsListProps) {
  const { t } = useTranslation();
  const {
    optionGroup: { options, productId, productOptionsTitle },
    index,
  } = props;
  const fieldName = 'productsSelections.optionsSingleMap';
  const productIdWithIndex = `${productId}-${index}`;

  return (
    <SecondLevelListWrapper
      heading={
        <Typography
          variant="subtitle2"
          neutralColorIndex={700}
          className="informa-payment-single-options__title"
        >
          {productOptionsTitle ||
            t(
              'site.pricing.products-selection.single-options-list.select-option.heading',
            )}
        </Typography>
      }
      className="informa-payment-single-options"
    >
      <RadioGroupField<PricingPackagesFormValues>
        name={`${fieldName}.${productIdWithIndex}`}
      >
        <MuiStack spacing={2}>
          {options.map((option) => {
            return (
              <CardWrapper
                paddingVariant="extraSmallTopBottom"
                enableBorder
                key={option.id}
                data-testid="single-option-list-item"
                className="informa-payment-single-options__item"
              >
                <Radio
                  value={option.id}
                  label={
                    <SecondLevelCard
                      title={
                        <TitleWithInlineElement
                          variant="featuredText"
                          title={option.name}
                          className="informa-payment-single-options-card__title"
                        >
                          {option.description && (
                            <ProductTooltipInfoIcon
                              text={option.description}
                              iconButtonSxProps={{ verticalAlign: 'bottom' }}
                            />
                          )}
                        </TitleWithInlineElement>
                      }
                      className="informa-payment-single-options-card"
                    />
                  }
                  labelOffset="small"
                  sx={{ m: 0 }}
                />
              </CardWrapper>
            );
          })}
        </MuiStack>
      </RadioGroupField>
    </SecondLevelListWrapper>
  );
}
